import * as React from "react";
const SvgMouse = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 14 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.7969 9.34766L0.942434 0.337489L2.31826 15.9748L6.66388 10.2473L13.7969 9.34766Z", fill: "currentColor" }));
export default SvgMouse;
